import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { InfoIcon } from '@phosphor-icons/react/Info';
import { useTranslation } from 'react-i18next';

export const StyledInfoRoundedIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledNoItemsWrapperDiv = styled('div')`
  display: flex;
  align-items: center;
  height: 100%;

  gap: ${({ theme }) => theme.spacing(1)};
`;

export const NoFiltersInfoAlert = () => {
  const { t } = useTranslation();

  return (
    <StyledNoItemsWrapperDiv data-test="empty-targeting">
      <StyledInfoRoundedIcon size={20} />
      <Typography>
        {t('No')} <strong>{t('Targeting Criteria')}</strong> {t('were applied.')}
      </Typography>
    </StyledNoItemsWrapperDiv>
  );
};
